<template>
  <div :class="'pane sunset-import-timesheets ' + prefix">

    <!-- HEADER (always visible) -->
    <div class="header-row">
      <div>
        <h2 style="margin-bottom: 0.25em;">
          Timesheet File Import Tool
        </h2>
        <p style="margin: 0;">
          Import timesheets into the portal in two simple steps.
        </p>
      </div>

      <div class="header-actions">
        <button
            class="btn orcaBtn"
            type="button"
            @click="open = !open"
            style="width: 170px"
        >
          {{ open ? 'Close' : 'Open' }}
        </button>
      </div>
    </div>

    <!-- EXPANDED CONTENT -->
    <div v-if="open">

      <!-- Collapsible Help -->
      <details class="pane import-info">
        <summary>
          <strong>Need help with this tool?</strong>
          <span class="help-hint">(click to expand)</span>
        </summary>

        <div class="import-info-content">
          <ul>
            <li>
              You can safely run the import more than once.
              Uploading the same file again will <strong>not lock sites</strong>.
            </li>

            <li>
              The template is automatically limited to the selected week.
            </li>

            <li>
              The importer will add <strong>as much valid data as possible</strong>.
              Only rows with problems are skipped.
            </li>

            <li>
              Any skipped rows are clearly shown as warnings.
              You can fix them and upload again.
            </li>
          </ul>

          <p style="margin-top: 0.75em;">
            If you get stuck, contact support and copy the page address below.
          </p>

          <div class="support-url">
            <label>Page address (copy and send to support):</label>
            <input
                type="text"
                :value="currentUrl"
                readonly
                @focus="$event.target.select()"
            />
          </div>
        </div>
      </details>

      <!-- Steps -->
      <div class="import-steps">

        <!-- STEP 1 -->
        <div class="pane import-step">
          <div class="step-header">
            <span class="step-badge">Step 1</span>
            <h4>Download the template</h4>
          </div>

          <timesheet_import_download_form
              :prefix="prefix"
              :company_id="company_id"
              :end_date="end_date"
          />
        </div>

        <!-- STEP 2 -->
        <div class="pane import-step">
          <div class="step-header">
            <span class="step-badge">Step 2</span>
            <h4>Upload your completed file (s).</h4>
          </div>

          <timesheet_import_upload_form
              :prefix="prefix"
              :company_id="company_id"
              :start_date="start_date"
              :end_date="end_date"
              :admin-mode="adminMode"
          />
        </div>

      </div>
    </div>
  </div>
</template>


<script>
import timesheet_import_upload_form from './timesheet_import_upload_form.vue';
import timesheet_import_download_form from './timesheet_import_download_form.vue';

export default {
  name: 'sunset_timesheet_import_widget',

  components: {
    timesheet_import_upload_form,
    timesheet_import_download_form,
  },

  props: {
    prefix: { required: true },
    company_id: { required: true },
    start_date: { required: true },
    end_date: { required: true },
    adminMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      open: false,
      currentUrl: '',
    };
  },

  created() {
    this.currentUrl = window.location.href;
  },
};
</script>

<style scoped>
.sunset-import-timesheets{
  display: grid;
  padding: 1em;
  grid-template-columns: 1fr;
  margin-bottom: 1em;
}

.header-actions{
  display: grid;
  grid-template-columns: 100%;
  justify-content: flex-end;
}

.pane {
  padding: 1em;
  background-color: white;
  border: 1px solid #eee;
  border-radius: 10px;
  margin-bottom: 1em;
}

/* Header row (always visible) */
.header-row {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 1em;
  margin-bottom: 1em;
}

/* Help */
.import-info {
  background-color: #fafafa;
}

.import-info summary {
  list-style: none;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.import-info summary::-webkit-details-marker {
  display: none;
}

.help-hint {
  font-size: 0.9em;
  color: #777;
}

.import-info-content {
  margin-top: 0.75em;
}

.import-info ul {
  margin: 0;
  padding-left: 1.25em;
}

.import-info li {
  margin-bottom: 0.5em;
}

/* Steps */
.import-steps {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5em;
}

.import-step {
  display: flex;
  flex-direction: column;
}

.step-header {
  display: flex;
  align-items: center;
  gap: 0.75em;
  margin-bottom: 0.75em;
}

.step-header h4 {
  margin: 0;
}

.step-badge {
  min-width: 65px;
  font-size: 1.1em;
  font-weight: 600;
  padding: 0.25em 0.6em;
  border-radius: 999px;
  border: 1px solid #999;
  color: #555;
}

/* Support URL */
.support-url {
  margin-top: 0.5em;
}

.support-url label {
  display: block;
  font-size: 0.9em;
  margin-bottom: 0.25em;
  color: #555;
}

.support-url input {
  width: 100%;
  padding: 0.5em;
  font-size: 0.9em;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #f9f9f9;
}

/* Buttons */
.btn {
  width: 170px;
  min-width: 170px;
  background-color: forestgreen;
}

@media (max-width: 1100px) {
  .import-steps {
    grid-template-columns: 1fr;
  }

  .header-row {
    grid-template-columns: 1fr;
    gap: 0.75em;
  }
}
</style>


